import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Address, OpenStreetMapAddress } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class GeoCodingService {
  private readonly httpClient = inject(HttpClient);

  getAddressFromCoordinates(lat: number, lng: number): Observable<Address> {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=18&addressdetails=1`;
    return this.httpClient.get(url).pipe(
      map((data: OpenStreetMapAddress) => {
        return {
          fullAddress: data.display_name,
          addressLine1: data.address.neighbourhood,
          addressLine2: data.address.suburb,
          zip: 11111,
          city: data.address.state,
          state: data.address.state,
          country: data.address.country,
          lat: parseFloat(data.lat),
          lng: parseFloat(data.lon)
        } as Address;
      })
    );
  }
}
